// extracted by mini-css-extract-plugin
export default {"optionsSpinner":"bDmwG","selectSpinner":"uJPLe"};